import Header from '../components/Header';
import Footer from '../components/Footer';

function BlogLayout({ children }) {
  return (
    <div className="ftm-page blog-page">
      <Header />
      <main className="blog-main">{children}</main>
      <Footer />
    </div>
  );
}

export default BlogLayout;
